export enum UserGroup {
	NHSSAA = 'nhssaa',
	COHORT_101 = '101',
	COHORT_201 = '201',
}
